import type { App as VueApp } from 'vue';
import { setupStores } from './setupStores';
import { setupRouter } from './setupRouter';
import { setupRuntime } from './setupRuntime';

import { verifyActivitySession, setCompany } from 'host/mfeBridge';
import { useCompanyStore } from '@Stores/company.store';

export const setupApp = async (app: VueApp<Element>) => {
    setupStores(app);
    setupRuntime(app);

    await initializeMfe();

    setupRouter(app);
};

const initializeMfe = async () => {
    await verifyActivitySession();

    try {
        const companyStore = useCompanyStore();
        if (companyStore.company) {
            setCompany(companyStore.company);
        }
    } catch (error) {
        console.error('[Dashboard MFE] Failed to initialize MFE:', error);
    }
};
